import { Dialog, DialogContent } from "@beweegbaas/ui";
import { createFileRoute, Outlet, stripSearchParams, useNavigate } from "@tanstack/react-router";
import {
  startLessonFlowSearchDefaults,
  startLessonFlowSearchSchema,
} from "#/modules/les.start-flow/filters";
import { getLesFlowLayoutData } from "#/modules/les.start-flow/les-flow.functions";
import { useRouteOverlayOpen } from "#/hooks/use-route-overlay-open";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/start/les-flow",
)({
  validateSearch: startLessonFlowSearchSchema,
  // Keep default-valued params out of the URL (nuqs parity with the RR7 portal): validateSearch
  // fills every default into the parsed search, this strips them back off before the URL is
  // written.
  search: { middlewares: [stripSearchParams(startLessonFlowSearchDefaults)] },
  // Narrowed to exactly the keys getLesFlowLayoutData reads — never the whole search object.
  loaderDeps: ({ search }) => ({
    beweegactiviteitenreeksSearchTerm: search.beweegactiviteitenreeksSearchTerm,
    sociaalEmotioneelThemasReeksSearchTerm: search.sociaalEmotioneelThemasReeksSearchTerm,
    includeDefaultsBeweeg: search.includeDefaultsBeweeg,
    includeDefaultsSociaal: search.includeDefaultsSociaal,
  }),
  loader: ({ deps }) => getLesFlowLayoutData({ data: deps }),
  component: LesFlowLayoutRoute,
});

function LesFlowLayoutRoute() {
  const { editLesId } = Route.useSearch();
  const params = Route.useParams();
  const navigate = useNavigate();
  const editWizard = useRouteOverlayOpen(() => {
    if (editLesId == null) return;
    // Closing the edit wizard returns to the les it was launched from.
    void navigate({
      to: "/$locale/{-$schoolyear}/$school/lesson/$lesson/teacher/scores",
      params: { ...params, lesson: editLesId },
      viewTransition: true,
    });
  });

  if (editLesId != null) {
    return (
      <Dialog {...editWizard}>
        <DialogContent
          className="top-[0.5rem] left-[0.5rem] h-[calc(100svh-1rem)]
            w-full max-w-[calc(100%-1rem)]! translate-none overflow-y-auto
            bg-neutral-50 max-md:p-0"
          showCloseButton={true}
        >
          <Outlet />
        </DialogContent>
      </Dialog>
    );
  }

  return <Outlet />;
}
